import React from 'react';
import { BRAND_CONFIG } from '@/config/brand';

interface LandingFooterProps {
  brandName?: string;
  variant?: 'A' | 'B';
  layout?: 'grid' | 'simple';
  children?: React.ReactNode; // 供 grid 版型放置自訂欄位
}

export const LandingFooter: React.FC<LandingFooterProps> = ({
  brandName,
  layout = 'simple',
  children,
}) => {
  if (layout === 'grid') {
    return (
      <footer className="w-full bg-white border-t border-gray-200/80">
        <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 px-4 py-12 md:px-6">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src={BRAND_CONFIG.logo} alt={BRAND_CONFIG.logoAlt} className="h-8 w-8" />
              <span className="text-lg font-bold text-wedding-text-title">{brandName ?? BRAND_CONFIG.name}</span>
            </div>
            <p className="text-sm text-gray-500">{BRAND_CONFIG.copyright}</p>
          </div>
          {/* 其他欄位由父層傳入 */}
          {children}
        </div>
      </footer>
    );
  }

  // simple
  return (
    <footer className="w-full border-t border-wedding-pink/20">
      <div className="container mx-auto flex flex-col items-center justify-between gap-4 px-4 py-8 md:flex-row md:px-6">
        <div className="flex items-center gap-2">
          <img src={BRAND_CONFIG.logo} alt={BRAND_CONFIG.logoAlt} className="h-6 w-6" />
          <span className="text-sm font-semibold text-wedding-text-title">{brandName ?? BRAND_CONFIG.name}</span>
        </div>
        <p className="text-sm">{BRAND_CONFIG.copyright}</p>
      </div>
    </footer>
  );
};
